// i18n/config.ts
import en from '@/lib/i18n/locales/en.json';
import ja from '@/lib/i18n/locales/ja.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const supportedLanguages = ['ja', 'en'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: supportedLanguages,
    fallbackLng: 'ja',
    returnEmptyString: false, // 空文字での定義を許可に
    resources: {
      ja: { translation: ja },
      en: { translation: en },
    },
    interpolation: {
      // 翻訳された文字列内のHTMLやReactコンポーネントをエスケープすることを無効に
      escapeValue: false,
      format: (value, format) => {
        if (format === 'number') {
          return value.toLocaleString();
        }
        return value;
      },
    },
    react: {
      // 指定したHTMLノードを翻訳時にそのまま保持して表示するための設定
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span'],
    },
  });

export default i18n;
